import React, { Component } from 'react';
import axios from 'axios';
import { Form, Button, FormGroup, Col, Modal } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table-2';
import config from '../../config/config';
import CoverNoteStatus from '../components/retrieveCoverNoteComponent/coverNoteStatus/CoverNoteStatus';
import AgentCodeName from '../components/agentCodeName/AgentCodeName';
import BusinessType from '../components/retrieveCoverNoteComponent/businessType/BusinessType';
import VehicleRegNo from '../components/retrieveCoverNoteComponent/vehicleRegNo/VehicleRegNo';
import CoverNoteNo from '../components/retrieveCoverNoteComponent/coverNoteNo/CoverNoteNo';
import InsuredName from '../components/retrieveCoverNoteComponent/insuredName/InsuredName';
import IssueDate from '../components/retrieveCoverNoteComponent/issueDate/IssueDate';
import ProgressBar from '../components/progressBar/ProgressBar';
import { momentToISOString, momentSetHKTimezoneWithFormat } from '../../utils/dateUtils'

const async = require('async');

const appUrlPath = `/${config.appUrlPath}`;

function getInitState() {
  const role = localStorage.getItem('role');
  const isPV = localStorage.getItem('isPV');
  const isCV = localStorage.getItem('isCV');

  const agentCode = role === 'agent' ? localStorage.getItem('agentCode') : '';
  const agentName = role === 'agent' ? localStorage.getItem('displayName') : '';
  return {
    redirect: false,
    isLoadingPDF: false,
    isLoading: false,
    coverNoteStatus: '',
    message: '',
    showModal: false,
    role,
    isPV,
    isCV,
    issueDateFrom: null,
    issueDateTo: null,
    agentCode,
    agentName,
    vehicleRegNo: '',
    coverNoteNo: '',
    insuredName: '',
    businessType: '',
    searchResult: [],
    totalDataSize: 0,
    selected: new Set(),
    page: 1
  }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
export class RetrieveCoverNote extends Component {

  constructor(props) {
    super(props);
    this.state = getInitState();

    this.handleChangeSearchCondition = this.handleChangeSearchCondition.bind(this);
    this.handleChangeIssueDateFrom = this.handleChangeIssueDateFrom.bind(this);
    this.handleChangeIssueDateTo = this.handleChangeIssueDateTo.bind(this);
    this.handleGetAgentName = this.handleGetAgentName.bind(this);
    this.handleChangeAgentCode = this.handleChangeAgentCode.bind(this);
    this.close = this.close.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.handleChangePrintCoverNote = this.handleChangePrintCoverNote.bind(this);
    this.printFormatter = this.printFormatter.bind(this);
    this.handleRowSelect = this.handleRowSelect.bind(this);
    this.handleCancelCoverNote = this.handleCancelCoverNote.bind(this);
    this.handleMarkOffCoverNote = this.handleMarkOffCoverNote.bind(this);
    this.confirmMarkOffCoverNote = this.confirmMarkOffCoverNote.bind(this);
    this.onAfterSaveCell = this.onAfterSaveCell.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {},
      headers: { 'ACTION-LOG': 'Access Retrieve Cover Note Page' }
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  onAfterSaveCell(row, cellName, cellValue) {
    row.policyNumber = cellValue;
  }

  onPageChange(page, sizePerPage) {
    this.getCoverNote(((page - 1) * sizePerPage), sizePerPage);
    this.setState({ page, selected: new Set() });
    this.table.cleanSelected();
  }

  getCoverNote(page, sizePerPage) {
    axios.get(`${appUrlPath}/getCoverNote`, {
      params: {
        limit: sizePerPage,
        skip: page,
        coverNoteStatus: this.state.coverNoteStatus,
        issueDateFrom: this.state.issueDateFrom,
        issueDateTo: this.state.issueDateTo,
        agentCode: this.state.agentCode,
        agentName: this.state.agentName,
        businessType: this.state.businessType,
        coverNoteNo: this.state.coverNoteNo,
        vehicleRegNo: this.state.vehicleRegNo,
        insuredName: this.state.insuredName
      }
    })
    .then((res) => {
      const searchResult = [];
      for (let i = 0; i < res.data.result.length; i++) {
        const data = res.data.result[i]
        const issueDate = momentSetHKTimezoneWithFormat(data.coverNoteEntry.createDate, 'DD/MM/YYYY');
        const effectiveDate = momentSetHKTimezoneWithFormat(data.coverageInfo.coveragePeriodFrom, 'DD/MM/YYYY');
        const expiryDate = momentSetHKTimezoneWithFormat(data.coverageInfo.coveragePeriodTo, 'DD/MM/YYYY');

        const searchResultObj = {
          coverNoteNo: data.coverNoteEntry.coverNoteNo,
          agentCode: data.coverNoteEntry.agentCode,
          issueDate,
          insuredName: data.coverNoteEntry.insuredName,
          vehicleRegNo: data.particularOfVehicle.vehicleRegNo,
          effectiveDate,
          expiryDate,
          coverNoteStatus: data.coverNoteStatus,
          productType: data.type,
          policyNumber: data.excessDetail.policyNumber
        }
        searchResult.push(searchResultObj)
      }

      this.setState({ searchResult, totalDataSize: res.data.resultCount, isLoading: false })
    })
    .catch((error) => {
      this.setState({
        message: error,
        showModal: true,
        isLoading: false
      });
    });
  }

  handleSelectAll(isSelected, rows) {
    if (isSelected) {
      const tmp = this.state.selected
      let i = 0;
      async.eachSeries(rows, (value, callback) => {
        tmp.add(JSON.stringify({ 'coverNoteNo': value.coverNoteNo, 'type': value.productType, 'rowIndex': i }))
        i++
        callback();
      }, () => {
        this.setState({ selected: tmp })
      });
    } else if (!isSelected) {
      this.setState({ selected: new Set() })
    }
  }

  handleChangePrintCoverNote(searchObj) {
    this.setState({ isLoadingPDF: true })
    if (searchObj.productType === 'coverNotePv') {
      axios.post(`${appUrlPath}/coverNotePVPrint`, searchObj, { responseType: 'arraybuffer' })
      .then((res) => {
        const file = new Blob([res.data], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE
          window.navigator.msSaveOrOpenBlob(file, `PV_Cover_Note_${searchObj.coverNoteNo}.pdf`);
        } else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
        }
        this.setState({ isLoadingPDF: false })
      }).catch((error) => {
        this.setState({
          message: error,
          showModal: true,
          isLoadingPDF: false
        });
      });
    } else if (searchObj.productType === 'coverNoteCv') {
      axios.post(`${appUrlPath}/coverNoteCVPrint`, searchObj, { responseType: 'arraybuffer' })
      .then((res) => {
        const file = new Blob([res.data], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE
          window.navigator.msSaveOrOpenBlob(file, `CV_Cover_Note_${searchObj.coverNoteNo}.pdf`);
        } else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
        }
        this.setState({ isLoadingPDF: false })
      }).catch((error) => {
        this.setState({
          message: error,
          showModal: true,
          isLoadingPDF: false
        });
      });
    }
  }

  handleClear() {
    this.setState(getInitState());
  }

  handleChangeSearchCondition(e) {
    const state = { ...this.state }
    if (e.target.id === 'coverNoteStatus') {
      state.coverNoteStatus = e.target.value
    } else if (e.target.id === 'businessType') {
      state.businessType = e.target.value
    } else if (e.target.id === 'coverNoteNo') {
      state.coverNoteNo = e.target.value
    } else if (e.target.id === 'vehicleRegNo') {
      state.vehicleRegNo = e.target.value
    } else if (e.target.id === 'insuredName') {
      state.insuredName = e.target.value
    }
    this.setState(state)
  }

  handleChangeIssueDateFrom(e) {
    this.setState({ issueDateFrom: e !== null ? momentToISOString(e) : null })
  }

  handleChangeIssueDateTo(e) {
    this.setState({ issueDateTo: e !== null ? momentToISOString(e) : null })
  }

  close() {
    this.setState({ showModal: false });
  }

  handleChangeAgentCode(e) {
    const agentCode = e.target.value;
    this.setState({
      agentCode
    });
  }

  handleGetAgentName(e) {
    const agentCode = e.target.value;
    axios.post(`${appUrlPath}/getAgentName`, {
      agentCode
    })
    .then((res) => {
      this.setState({
        agentName: res.data.agentName
      })
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.role === 'agent' && this.state.businessType === '' && this.state.coverNoteNo === '') {
      this.setState({
        message: 'Please fill in the business type or cover note no.',
        showModal: true
      });
      return
    }
    this.setState({ isLoading: true, selected: new Set() }, () => {
      this.getCoverNote(0, 10);
    })
  }

  handleClick() {
    window.history.back();
  }

  colFormatter(cell, row) {
    let form = '/coverNotePvForm'
    if (row.productType === 'coverNotePv') {
      form = '/coverNotePvForm'
    } else if (row.productType === 'coverNoteCv') {
      form = '/coverNoteCvForm'
    }
    const link = `/en${appUrlPath}${form}?coverNoteNo=${cell}`
    return (<a href={link}>{cell}</a>)
  }

  printFormatter(cell, row) {
    const searchObj = { 'productType': row.productType, 'coverNoteNo': row.coverNoteNo }
    return (<button type="button" className="btn btn-axa btn-xs" onClick={() => this.handleChangePrintCoverNote(searchObj)}>Print</button>)
  }

  handleRowSelect(row, isSelected, e, rowIndex) {
    const selected = this.state.selected
    if (isSelected) {
      selected.add(JSON.stringify({ 'coverNoteNo': row.coverNoteNo, 'type': row.productType, 'rowIndex': rowIndex }))
    } else {
      selected.delete(JSON.stringify({ 'coverNoteNo': row.coverNoteNo, 'type': row.productType, 'rowIndex': rowIndex }))
    }
    this.setState({ selected })
  }

  handleCancelCoverNote(event) {
    event.preventDefault();
    axios.post(`${appUrlPath}/cancelCoverNote`, {
      coverNoteSet: this.state.selected
    })
    .then((response) => {
      this.setState({ message: response.data, showModal: true, selected: new Set() });
      this.onPageChange(this.state.page, 10)
      this.table.setState({
        selectedRowKeys: []
      });
    })
    .catch((error) => {
      this.setState({ message: error.response.data.message, showModal: true });
    })
    ;
  }

  handleMarkOffCoverNote(event) {
    event.preventDefault();
    const iter = this.state.selected.values();
    let valid = true;
    const page = this;
    const markOffList = [];
    async.forEachOf(iter, (value, key, callback) => {
      const result = page.state.searchResult.find((item) => item["coverNoteNo"] === JSON.parse(value).coverNoteNo);
      const markOff = { 'coverNoteNo': result.coverNoteNo, 'type': result.productType, 'policyNumber': result.policyNumber };
      if (result.policyNumber) {
        markOffList.push(markOff);
      } else {
        valid = false;
      }
      callback();
    }, () => {
      if (valid) {
        page.confirmMarkOffCoverNote(markOffList);
      } else {
        // If Policy Number is empty, prompt error
        page.setState({
          message: 'Please enter the policy number before marking off the policy.',
          showModal: true
        });
      }
    });
  }

  confirmMarkOffCoverNote(markOffList) {
    axios.post(`${appUrlPath}/markOffCoverNote`, {
      coverNoteSet: markOffList
    })
    .then((response) => {
      this.setState({ message: response.data, showModal: true, selected: new Set() });
      this.onPageChange(this.state.page, 10)
      this.table.setState({
        selectedRowKeys: []
      });
    })
    .catch((error) => {
      this.setState({ message: error.response.data.message, showModal: true });
    });
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ color: 'blue' }}>
        From { start } to { to }, total is { total }
      </p>
    );
  }

  render() {
    if (this.state.isLoadingPDF || this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    const options = {
      sizePerPageList: [], // you can change the dropdown list for size per page
      sizePerPage: 10,  // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 3,  // the pagination bar size.
      prePage: 'Prev', // Previous page button text
      nextPage: 'Next', // Next page button text
      firstPage: 'First', // First page button text
      lastPage: 'Last', // Last page button text
      prePageTitle: 'Go to previous', // Previous page button title
      nextPageTitle: 'Go to next', // Next page button title
      firstPageTitle: 'Go to first', // First page button title
      lastPageTitle: 'Go to Last', // Last page button title
      paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
      paginationPosition: 'bottom',  // default is bottom, top and both is all available
      onPageChange: this.onPageChange,
      page: this.state.page,
      onSizePerPageList: this.onSizePerPageList
    };

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: true,  // enable click to select
      onSelect: this.handleRowSelect,
      onSelectAll: this.handleSelectAll
    };

    const cellEditProp = {
      mode: 'click',
      blurToSave: true,
      afterSaveCell: this.onAfterSaveCell
    }

    return (
      <div>
        { this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          {
            this.state.message
          }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}
        <h2 className="ebaoUtil__HeaderTwo">Retrieve Cover Note</h2>
        <h3 className="ebaoUtil__HeaderThree">Search Condition (Business Type or Cover Note Number required)</h3>
        <Form onSubmit={this.handleSubmit}>
          <div className="ebaoUtil__Form-100">
            <FormGroup controlId="coverNoteStatus">
              <Col sm={6}>
                <CoverNoteStatus
                  coverNoteStatus={this.state.coverNoteStatus}
                  handleChangeCoverNoteStatus={this.handleChangeSearchCondition}
                />
              </Col>
              <Col sm={6}>
                <AgentCodeName
                  agentCode={this.state.agentCode}
                  agentName={this.state.agentName}
                  handleGetAgentName={this.handleGetAgentName}
                  handleChangeAgentCode={this.handleChangeAgentCode}
                  systemRole={this.state.role}
                  required={false}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="">
              <Col sm={6}>
                <BusinessType
                  businessType={this.state.businessType}
                  handleChangeBusinessType={this.handleChangeSearchCondition}
                  role={this.state.role}
                  isPV={this.state.isPV}
                  isCV={this.state.isCV}
                />
              </Col>
              <Col sm={6}>
                <VehicleRegNo
                  vehicleRegNo={this.state.vehicleRegNo}
                  handleChangeVehicleRegNo={this.handleChangeSearchCondition}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="">
              <Col sm={6}>
                <CoverNoteNo
                  coverNoteNo={this.state.coverNoteNo}
                  handleChangeCoverNoteNo={this.handleChangeSearchCondition}
                />
              </Col>
              <Col sm={6}>
                <InsuredName
                  insuredName={this.state.insuredName}
                  handleChangeInsuredName={this.handleChangeSearchCondition}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="">
              <IssueDate
                startDateLabel="Issue Date From"
                endDateLabel="Issue Date To"
                startDate={this.state.issueDateFrom}
                endDate={this.state.issueDateTo}
                handleChangeStartDate={this.handleChangeIssueDateFrom}
                handleChangeEndDate={this.handleChangeIssueDateTo}
              />
            </FormGroup>
            <FormGroup controlId="">
              <Col sm={6} />
              <Col sm={6}>
                <div className="ebaoUtil__Row">
                  <div className="ebaoUtil__ButtonGroup">
                    <button type="submit" className="btn btn-axa">Search</button>{' '}
                    <button type="button" className="btn btn-axa" onClick={this.handleClear}>Clear</button>
                  </div>
                </div>
              </Col>
            </FormGroup>
          </div>
       </Form>
       <br /><br /><br /><br />
       <BootstrapTable
          data={this.state.searchResult}
          pagination
          options={options}
          remote
          fetchInfo={{ dataTotalSize: this.state.totalDataSize }}
          selectRow={selectRowProp}
          cellEdit={cellEditProp}
          ref={(c) => { this.table = c; }}
       >
          { this.state.role !== 'agent' ?
            <TableHeaderColumn editable={false} dataFormat={this.colFormatter} dataField="coverNoteNo" isKey>CN No.</TableHeaderColumn> :
            <TableHeaderColumn editable={false} dataField="coverNoteNo" isKey>CN No.</TableHeaderColumn>}

          <TableHeaderColumn editable={false} dataField="agentCode">Agent Code</TableHeaderColumn>
          <TableHeaderColumn editable={false} dataField="issueDate">Issued Date/Time</TableHeaderColumn>
          <TableHeaderColumn editable={false} dataField="insuredName">Insured</TableHeaderColumn>
          <TableHeaderColumn editable={false} dataField="vehicleRegNo">Veh. Reg. No.</TableHeaderColumn>
          <TableHeaderColumn editable={false} dataField="effectiveDate">Eff.Date</TableHeaderColumn>
          <TableHeaderColumn editable={false} dataField="expiryDate">Expiry Date</TableHeaderColumn>
          <TableHeaderColumn editable={false} dataField="coverNoteStatus">Status</TableHeaderColumn>
          <TableHeaderColumn editable dataField="policyNumber">Policy No.</TableHeaderColumn>
          <TableHeaderColumn editable={false} dataFormat={this.printFormatter} dataField="printCoverNote">Print CN</TableHeaderColumn>

        </BootstrapTable>
        <div className="ebaoUtil__Row">
          <div className="ebaoUtil__ButtonGroup">
            {this.state.role === 'agent' ?
              <button type="button" className="btn btn-axa" disabled >Cancel Cover Note</button> :
              <button type="button" className="btn btn-axa" onClick={this.handleCancelCoverNote}>Cancel Cover Note</button>
            }
            {' '}
            {this.state.role === 'agent' ?
              <button type="button" className="btn btn-axa" disabled >Mark-off</button> :
              <button type="button" className="btn btn-axa" onClick={this.handleMarkOffCoverNote}>Mark-off</button>
            }
            {' '}
            <button type="button" className="btn btn-axa" onClick={this.handleClick}>Back</button>
          </div>
        </div>
    </div>

    )
  }
}

export default RetrieveCoverNote;


// WEBPACK FOOTER //
// ./src/app/pages/RetrieveCoverNote.js